import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import colors from '../assets/colors.js'

const styles = {
	copyright: {
		color: colors.greyLight,
		marginTop: '10px',
	},
	footer: {
	  background: colors.greyDark,
	  color: 'white',
	  fontSize: '16px',
	  padding: '40px',
	},
};

class Footer extends React.Component {

  render() {
    const { classes } = this.props;
    const year = new Date().getFullYear();

    return (
      <footer className={classes.footer}>
			  <div>Erich &amp; Hannah Sachs Foundation • 1000 4th Street • Suite 875 • San Rafael, CA 94901 • Tel: 707.815.0140 / 917.880.5725</div>
				<div className={classes.copyright}>Copyright © {year} Erich & Hannah Sachs Foundation</div>
			</footer>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);




// WEBPACK FOOTER //
// ./src/components/Footer.js